import { TableSortTypes } from '@/common/components/redesigned/Table/types/tableTypes';

export const SORT_ORDER: Record<TableSortTypes, string> = {
  [TableSortTypes.ASCEND]: 'asc',
  [TableSortTypes.DESCEND]: 'desc',
};

/**
 * Приводит порядок сортировки из формата таблицы (ascend/descend) к формату бэка (asc/desc).
 * sortColumn не трогаем — ключи колонок (name/updateDate) уже совпадают с ожидаемыми бэком.
 */
//TODO: Привести сортировку таблиц на проекте к виду (asc/desc)
export const mapSortParams = <T extends Record<string, unknown>>(params: T): T => {
  const { sortOrder } = params;

  if (typeof sortOrder === 'string' && sortOrder in SORT_ORDER) {
    return { ...params, sortOrder: SORT_ORDER[sortOrder as TableSortTypes] };
  }

  return params;
};
